import { render, staticRenderFns } from "./SvgBox.vue?vue&type=template&id=5e2573ab&"
import script from "./SvgBox.vue?vue&type=script&lang=js&"
export * from "./SvgBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports